import fetch from "./fetch";

 const channel = {
  // /dm-channel/page
  channelpage(params){
    return fetch({
      url:"/dm-channel/page",
      method:"GET",
      params,
    })
  },
  // POST /dm-channel/save
  channelSave(data){
    return fetch({
      isLoading: true,
      url:"/dm-channel/save",
      method: "POST",
      data
    })
  },
  // /dm-channel/update
  channelupdate(data){
    return fetch({
      isLoading: true,
      url:"/dm-channel/update",
      method: "POST",
      data
    })
  },
  // /dm-channel/downloadTem
  channeldownloadTem(){
    return fetch({
      isLoading: true,
      url: "/dm-channel/downloadTem",
      method: "GET",
      responseType: "blob",
    });
  },
}
export default channel